<div id="splash-page">
    <div id="loader">
        <app-spinner id="translate-spinner"></app-spinner>
    </div>
    <router-outlet></router-outlet>
</div>
